module.exports={render:function (){with(this) {
  return _h('ul', {
    staticClass: "small-menu"
  }, [_l((items), function(item) {
    return _h('li', [_h('router-link', {
      attrs: {
        "to": {
          path: item.url
        }
      }
    }, [_h('span', [_s(item.text), _m(0)])])])
  })])
}},staticRenderFns: [function (){with(this) {
  return _h('em')
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/template-compiler.js?id=data-v-8!./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmallMenu.vue
 ** module id = 39
 ** module chunks = 2
 **/